/* eslint-disable react-hooks/exhaustive-deps */
import { withRouter } from "../_shared/withRouter";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import JSZip from "jszip";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import SidebarArrow from "../template/_common/sidebarArrow";
import ViewQrModal from "../template/admin/viewQrModal";
import { globalAlert, globalLoader } from "../actions/commonActions";
import { physicalCardBulkUploadApi } from "./_actions";
import { exportData, logOut } from "../_shared/commonFunction";
import { Helmet } from "react-helmet";

const CSV_TEMPLATE =
  "cardIdentifier,mobile\r\nCARD-EXAMPLE-001,07700900000\r\n";

const dataUrlToUint8Array = (dataUrl) => {
  const base64 = dataUrl.split(",")[1] || "";
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

const PhysicalCardBulkUpload = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [file, setFile] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrModalData, setQrModalData] = useState(null);

  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };

  const handleDownloadFormat = () => {
    exportData(
      CSV_TEMPLATE,
      "physical-cards-template.csv",
      "text/csv"
    );
  };

  const openQrPreview = (qr) => {
    setQrModalData({
      qrCodeImage: qr.dataUrl,
      storeName: qr.cardIdentifier,
    });
    setQrModalOpen(true);
  };

  const handleDownloadAllQr = async () => {
    if (!uploadResult?.qrCodes?.length) return;
    try {
      globalLoader(true);
      const zip = new JSZip();
      uploadResult.qrCodes.forEach((qr) => {
        zip.file(`${qr.cardIdentifier}.png`, dataUrlToUint8Array(qr.dataUrl));
      });
      const blob = await zip.generateAsync({ type: "blob" });
      exportData(
        blob,
        `physical-cards-qr-${new Date().getTime()}.zip`,
        "application/zip"
      );
      globalLoader(false);
    } catch (err) {
      globalLoader(false);
      globalAlert("error", t("common.somethingWentWrong"));
    }
  };

  const setFileFunc = (ev) => {
    const selected = ev?.target?.files[0];
    if (!selected) return;
    if (
      selected.type === "text/csv" ||
      selected.type === "application/vnd.ms-excel" ||
      selected.name.endsWith(".csv")
    ) {
      if (selected.size > 2 * 1024 * 1024) {
        globalAlert("error", t("admin.physicalCards.fileTooLarge"));
        return;
      }
      setFile(selected);
      setUploadResult(null);
    } else {
      globalAlert("error", t("admin.physicalCards.csvOnly"));
    }
  };

  const handleUpload = async () => {
    if (!file) {
      globalAlert("error", t("admin.physicalCards.fileRequired"));
      return;
    }
    try {
      globalLoader(true);
      const formData = new FormData();
      formData.append("csvFile", file);
      const res = await physicalCardBulkUploadApi(formData);
      if (res?.data?.status === 200) {
        setUploadResult(res.data.data);
        setFile(null);
        globalAlert("success", t("admin.physicalCards.uploadSuccess"));
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);
      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };

  return (
    <div className="admin-portal">
      <Helmet>
        <title>{t("admin.pageTitle.physicalCards")} - eC-Card</title>
      </Helmet>
      <Header roleType="admin" />
      <div className={`${navbarToggle ? "active" : ""} wrapper`}>
        <SidebarComponent
          navbarToggle={navbarToggle}
          active={props.match.path}
          menu="manageVenue"
          subMenu="physical-cards"
        />
        <div className="main">
          <SidebarArrow handleSidebarToggle={handleSidebar} />
          <div className="main-wrapper">
            <div className="listing">
              <div className="row m-0">
                <div className="col-12">
                  <h3 className="page-title">
                    {t("admin.physicalCards.title")}
                  </h3>
                </div>
              </div>

              <div className="px-3 pt-3">
                <div className="card-own p-4">
                  <p className="mb-3 font-weight-bold">
                    {t("admin.physicalCards.instructions")}
                  </p>

                  <div className="upload-btn upload-btn-dashed mb-3">
                    {file && file.name && (
                      <div className="show-icon-wrapper pb-2 mb-1">
                        {file.name}
                      </div>
                    )}
                    <div className="upload-btn-txt btn">
                      {file
                        ? t("admin.physicalCards.changeFile")
                        : t("admin.physicalCards.selectFile")}
                    </div>
                    <input
                      type="file"
                      accept=".csv"
                      className="upload-input cursor"
                      onChange={setFileFunc}
                      data-testid="pc-csv-input"
                    />
                  </div>

                  <button
                    className="btn primary-btn px-4"
                    onClick={handleUpload}
                    disabled={!file}
                    data-testid="pc-upload-btn"
                  >
                    {t("admin.physicalCards.upload")}
                  </button>
                  <button
                    className="btn primary-btn px-4 ml-2"
                    onClick={handleDownloadFormat}
                    data-testid="pc-download-format-btn"
                  >
                    {t("admin.physicalCards.downloadFormat")}
                  </button>
                </div>
              </div>

              {uploadResult && (
                <div className="px-3 pt-3" data-testid="pc-upload-results">
                  <div className="card-own p-4">
                    <h5 className="font-weight-bold mb-3">
                      {t("admin.physicalCards.results")}
                    </h5>
                    <div className="row mb-3">
                      <div className="col-3">
                        <div className="stats-card p-3 text-center">
                          <div className="stats-value">
                            {uploadResult.processed}
                          </div>
                          <div className="stats-label">
                            {t("admin.physicalCards.processed")}
                          </div>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="stats-card p-3 text-center">
                          <div className="stats-value text-success">
                            {uploadResult.matched}
                          </div>
                          <div className="stats-label">
                            {t("admin.physicalCards.matched")}
                          </div>
                        </div>
                      </div>
                      <div className="col-3">
                        <div className="stats-card p-3 text-center">
                          <div className="stats-value text-danger">
                            {uploadResult.unmatched}
                          </div>
                          <div className="stats-label">
                            {t("admin.physicalCards.unmatched")}
                          </div>
                        </div>
                      </div>
                      {uploadResult.cooldownSkipped > 0 && (
                        <div className="col-3">
                          <div className="stats-card p-3 text-center">
                            <div className="stats-value text-warning">
                              {uploadResult.cooldownSkipped}
                            </div>
                            <div className="stats-label">
                              {t("admin.physicalCards.cooldownSkipped")}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    {uploadResult.errors && uploadResult.errors.length > 0 && (
                      <div>
                        <h6 className="font-weight-bold mb-2 text-danger">
                          {t("admin.physicalCards.errors")}
                        </h6>
                        <div className="table-wrapper-scroll-y table-scrollbar">
                          <div className="table-own table-responsive">
                            <table className="table table-striped table-hover table-admin">
                              <thead className="table-head">
                                <tr>
                                  <th>{t("admin.physicalCards.errorRow")}</th>
                                  <th>
                                    {t(
                                      "admin.physicalCards.report.cardIdentifier"
                                    )}
                                  </th>
                                  <th>{t("common.mobile")}</th>
                                  <th>
                                    {t("admin.physicalCards.errorReason")}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="table-body">
                                {uploadResult.errors.map((err, idx) => (
                                  <tr key={idx}>
                                    <td>{err.row}</td>
                                    <td>{err.cardIdentifier || "-"}</td>
                                    <td>{err.mobile || "-"}</td>
                                    <td>{err.reason}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* PR3: cooldown-skipped rows are informational, not
                        errors. Rendered as a separate amber/warning section
                        so admins can see *which* mobiles were skipped
                        without confusing them with validation failures. */}
                    {uploadResult.skipped &&
                      uploadResult.skipped.length > 0 && (
                        <div className="mt-3" data-testid="pc-skipped-section">
                          <h6 className="font-weight-bold mb-2 text-warning">
                            {t("admin.physicalCards.skipped")}
                          </h6>
                          <div className="table-wrapper-scroll-y table-scrollbar">
                            <div className="table-own table-responsive">
                              <table className="table table-striped table-hover table-admin">
                                <thead className="table-head">
                                  <tr>
                                    <th>{t("admin.physicalCards.errorRow")}</th>
                                    <th>
                                      {t(
                                        "admin.physicalCards.report.cardIdentifier"
                                      )}
                                    </th>
                                    <th>{t("common.mobile")}</th>
                                    <th>
                                      {t("admin.physicalCards.errorReason")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="table-body">
                                  {uploadResult.skipped.map((row, idx) => (
                                    <tr key={idx}>
                                      <td>{row.row}</td>
                                      <td>{row.cardIdentifier || "-"}</td>
                                      <td>{row.mobile || "-"}</td>
                                      <td>{row.reason}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}

                    {uploadResult.qrCodes &&
                      uploadResult.qrCodes.length > 0 && (
                        <div className="mt-4">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="font-weight-bold mb-0">
                              {t("admin.physicalCards.qrCodes")} (
                              {uploadResult.qrCodes.length})
                            </h6>
                            <button
                              className="btn primary-btn px-4"
                              onClick={handleDownloadAllQr}
                            >
                              {t("admin.physicalCards.downloadAllQr")}
                            </button>
                          </div>
                          <div className="row">
                            {uploadResult.qrCodes.map((qr) => (
                              <div
                                key={qr.cardIdentifier}
                                className="col-6 col-md-3 col-lg-2 mb-3"
                              >
                                <div
                                  className="card-own p-2 text-center cursor"
                                  onClick={() => openQrPreview(qr)}
                                >
                                  <img
                                    src={qr.dataUrl}
                                    alt={qr.cardIdentifier}
                                    style={{ width: "100%", height: "auto" }}
                                  />
                                  <div
                                    className="mt-2 text-truncate"
                                    title={qr.cardIdentifier}
                                  >
                                    {qr.cardIdentifier}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {qrModalOpen && (
        <ViewQrModal
          open={qrModalOpen}
          closeModal={() => setQrModalOpen(false)}
          data={qrModalData}
        />
      )}
    </div>
  );
};

export default withRouter(PhysicalCardBulkUpload);
